import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { MainPhoneMenu, MainPhoneState } from '../main-phone-state';
import { getFeatureState } from './feature.selector';

export const getPhoneState: MemoizedSelector<MainPhoneMenu, StateUtils.LoaderState<string>> = createSelector(
  getFeatureState,
  (state: MainPhoneState) => state.phone,
);

export const getPhoneValue: MemoizedSelector<MainPhoneMenu, string> = createSelector(
  getPhoneState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderValueSelector(state),
);

export const getPhoneLoading: MemoizedSelector<MainPhoneMenu, boolean> = createSelector(
  getPhoneState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderLoadingSelector(state),
);

export const getPhoneError: MemoizedSelector<MainPhoneMenu, boolean> = createSelector(
  getPhoneState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderErrorSelector(state),
);

export const getPhoneSuccess: MemoizedSelector<MainPhoneMenu, boolean> = createSelector(
  getPhoneState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderSuccessSelector(state),
);
